// extracted by mini-css-extract-plugin
module.exports = {"root":"layout_base_root__P4r2e"};